// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import type { ThunkAction } from '../../types';

export function updateCurrentUser(
  userId: number,
  organisationId: ?number = undefined
): ThunkAction {
  return function(dispatch, getState) {
    if (userId) {
      // Get the user details
      const global = organisationId ? false : true;
      return dispatch(getUser(userId, organisationId, true, global)).then(
        user => {
          dispatch(clearCurrentUser());
          dispatch({ type: 'UPDATE_CURRENT_USER', user });
        }
      );
    } else {
      return dispatch(clearCurrentUser());
    }
  };
}

export function getUser(
  userId: number,
  organisationId: ?number = undefined,
  withSettings: boolean = true,
  global: boolean = false
): ThunkAction {
  return function(dispatch, getState) {
    if (!global) {
      organisationId = organisationId || getState().currentOrganisation.id;
    } else {
      organisationId = undefined;
    }
    const endpoint = `/user/${userId}`;
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId,
        withSettings
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        const userWithSettings = response.data;
        return userWithSettings;
      },
      error => dispatch(APIError(error, 'Error getting User'))
    );
  };
}

export type ClearCurrentUserAction = {
  type: 'CLEAR_CURRENT_USER'
};

export function clearCurrentUser(): ClearCurrentUserAction {
  return { type: 'CLEAR_CURRENT_USER' };
}

export function getUserLocations(userId: number): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/user/suborganisations/${userId}`;
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        dispatch({ type: 'GET_USER_LOCATIONS', locations: response.data });
        return response;
      },
      error => dispatch(APIError(error, 'Error getting user locations'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/users/currentUserCreators.js